import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import {
  getListNotifyIncomeFailed,
  getListNotifyIncomeStart,
  getListNotifyIncomeSuccess,
  updateOtherDataNotifyIncome,
} from "../redux/getListNotifyIncome";
import { InfiniteScrollKey } from "components/common/ListInfinitiveScrolling/const";
import { getListNotifyIncomeApi } from "core/http/service/salary";
import { filterSalaryNotifyIncomeSelector } from "../redux/selector";
import { getDetailNotifyIncomeStart } from "../redux/getDetailNotifyIncome";
import { SCREEN } from "helper/roleChecker/Screens";
import { ReduxStateType } from "redux-store/types";

function* getListNotifyIncome(action) {
  try {
    const payload = action.payload;

    const { offset, limit } = yield select(
      controlInfinitiveScrollSelector(InfiniteScrollKey.INCOME)
    );
    const { year } = yield select(filterSalaryNotifyIncomeSelector);
    const params = {
      offset: offset,
      limit: limit,
      year: year,
      ...payload,
    };
    const res = yield call(getListNotifyIncomeApi, params);
    yield put({
      type: getListNotifyIncomeSuccess.type,
      payload: {
        data: res?.data || [],
      },
    });
    yield put({
      type: updateOtherDataNotifyIncome.type,
      payload: {
        monthYear: res?.monthYear,
        salary: res?.salary,
      },
    });
    if (res?.data && res?.data?.length) {
      yield put({
        type: getDetailNotifyIncomeStart.type,
        payload: {
          id: res.data[0].incomeNotifyId,
          screen: SCREEN.IP_027,
          monthYear: res?.data[0]?.monthYear,
        },
      }); // mặc định lấy detail của item đầu tiên trong list
    }
  } catch (error: any) {
    yield put({
      type: getListNotifyIncomeFailed.type,
      payload:
        error?.type === ReduxStateType.UNAUTHORIZED ? error.type : undefined,
    });
  }
}
function* watchGetListNotifyIncome() {
  yield takeLatest(getListNotifyIncomeStart.type, getListNotifyIncome);
}

export default function* getListNotifyIncomeSaga() {
  yield all([watchGetListNotifyIncome()]);
}
